import {
  IAuditLog,
  IAutoCollectActiveFields,
  IAutoCollectOwner,
  IAutoCollectPrefilledFields,
  ICustomEmailContent,
  IHttpsCallableFailResponse,
  IHttpsCallableSuccessResponse,
  UserType,
  UUID
} from "../../../src/app/core/interfaces";
import { IOwnerDTO } from "./owner-interfaces";

export interface ISendMultipleAutoCollectEmailsReq {
  orgId: UUID;
  entityName?: string;
  ownerIds: UUID[];
}

interface ISendMultipleAutoCollectEmailsSuccessRes extends IHttpsCallableSuccessResponse {
  owners: IOwnerDTO[];
}

export type ISendMultipleAutoCollectEmailsRes = ISendMultipleAutoCollectEmailsSuccessRes | IHttpsCallableFailResponse;

export interface ISendSingleAutoCollectEmailReq {
  userType: UserType;
  ownerId: string;
  email: string;
  name: string;
  senderName: string;
  companyName: string;
  senderPhone?: string;
  senderEmail?: string;
}
export interface IProSendSingleAutoCollectEmailReq extends ISendSingleAutoCollectEmailReq {
  userType: "secure-pro";
  orgId: UUID;
  customEmailContent?: ICustomEmailContent;
}
export interface IFileSendSingleAutoCollectEmailReq extends ISendSingleAutoCollectEmailReq {
  userType: "secure-file";
  entityId: UUID;
}

interface ISendSingleAutoCollectEmailSuccessRes extends IHttpsCallableSuccessResponse {
  updatedOwner: IOwnerDTO;
}
export type ISendSingleAutoCollectEmailRes = ISendSingleAutoCollectEmailSuccessRes | IHttpsCallableFailResponse;

export interface ISendAutoCollectEmailJWTPayload {
  userType: UserType;
  ownerId: string;
  name: string;
  entityId?: string;
  groupId?: string;
  orgId?: string;
  legalName?: string;
  senderName: string;
  senderPhone?: string | null;
  senderEmail?: string | null;
  exp: number;
}

export interface IDecodeImageCollectionJwtReq {
  token: string;
}

export interface IDecodeImageCollectionJwtSuccessRes extends IHttpsCallableSuccessResponse {
  message: string;
  decoded: ISendAutoCollectEmailJWTPayload;
  fieldStatuses: IAutoCollectActiveFields;
  prefilledFields: IAutoCollectPrefilledFields;
}
export type IDecodeImageCollectionJwtRes = IDecodeImageCollectionJwtSuccessRes | IHttpsCallableFailResponse;

export interface IAutoCollectUploadOwnerReq {
  token: string;
  owner: Partial<IAutoCollectOwner>;
  auditLog: IAuditLog[];
}
